<template>
	<div class="details">
		<VideosDetails />
	</div>
</template>

<script>
import VideosDetails from "@student/videos/child/videosDetails.vue";
export default {
	components: {
		VideosDetails,
	},
	data() {
		return {
			
		};
	},
    mounted(){
        
    },
	methods: {},
};
</script>
